<template>
    <div>
        <Modal
            v-model="showModal"
            draggable
            sticky
            title="Project Time Logs"
            width="800"
            no-footer
            class="projectLogDisputeModal"
        >
            <div class="modal-body">
                <Table
                    :columns="tblColumns"
                    :data="tblData"
                    size="small"
                    :loading="isLoading"
                    class="projectTimeLogsList"
                />
            </div>
            <div slot="footer">
                <Button class="pt-btn-2" @click="showModal = false">CLOSE</Button>
            </div>
        </Modal>
        <EditProjectLogModal ref="EditProjectLog" @success="getProjectTimeLogs" />
    </div>
</template>

<script>
import moment from 'moment';
import { getTimelogsByUserV2 } from '@/services/timelogs.services';
import EditProjectLogModal from './EditProjectLogModal.vue';

export default {
    components: {
        EditProjectLogModal,
    },
    data() {
        return {
            showModal: false,
            isLoading: false,
            userId: null,
            tblData: [],
            tblColumns: [
                {
                    title: 'Project Name',
                    key: 'projectName',
                    render: (h, params) => {
                        return h('div', params.row.project ? params.row.project.name : '-');
                    },
                },
                {
                    title: 'Start Time',
                    key: 'startTime',
                    render: (h, params) => {
                        return params.row.startTime
                            ? h('div', moment(params.row.startTime).utc().format('DD-MMM-YYYY hh:mm A'))
                            : h('div', { class: 'hyphenFont' }, '-');
                    },
                },
                {
                    title: 'End Time',
                    key: 'endTime',
                    render: (h, params) => {
                        return params.row.endTime
                            ? h('div', moment(params.row.endTime).utc().format('DD-MMM-YYYY hh:mm A'))
                            : h('div', { class: 'hyphenFont' }, '-');
                    },
                },
                {
                    title: 'Total Hours',
                    key: 'rowDaily',
                    align: 'center',
                    render: (h, params) => {
                        return params.row.rowDaily
                            ? h('div', Number(params.row.rowDaily).toFixed(2))
                            : h('div', { class: 'hyphenFont' }, '-');
                    },
                },
                {
                    title: 'Actions',
                    key: 'actions',
                    align: 'center',
                    render: (h, params) => {
                        return h('div', [
                            h(
                                'Button',
                                {
                                    props: {
                                        type: 'primary',
                                        size: 'small',
                                        icon: 'md-create',
                                    },
                                    style: {
                                        marginRight: '5px',
                                    },
                                    on: {
                                        click: () => {
                                            const index = params.index;
                                            const timelog = params.row;
                                            const prevTimelog =
                                                index < this.tblData.length - 1 ? this.tblData[index + 1] : null;
                                            const nextTimelog = index > 0 ? this.tblData[index - 1] : null;
                                            this.$refs.EditProjectLog.openModal(timelog, prevTimelog, nextTimelog);
                                        },
                                    },
                                },
                                'Edit'
                            ),
                        ]);
                    },
                },
            ],
        };
    },
    methods: {
        openModal(userId) {
            this.userId = userId;
            this.showModal = true;
            this.getProjectTimeLogs();
        },
        async getProjectTimeLogs() {
            this.isLoading = true;
            this.tblData = [];
            try {
                const res = await getTimelogsByUserV2();
                this.tblData = res.data || [];
            } catch (error) {
                this.$Message.error('Failed to get project timelogs');
            } finally {
                this.isLoading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.projectLogDisputeModal {
    .modal-body {
        padding: 10px;
    }
}
</style>
